<template>
  <el-input
    :placeholder="`${placeholder || '6-16位，至少含数字、字母、特殊字符2种组合'}`"
    :type="type"
    v-model="privateValue"
    :maxlength="16"
    @focus="onInputFocus"
    @blur="onInputBlur"
    @keydown.native.enter="onEnter"
  >
    <template v-slot:append>
      <div
        class="view"
        :class="type"
        @click="type == 'text' ? (type = 'password') : (type = 'text')"
      ></div>
    </template>
  </el-input>
</template>
<script>
export default {
  name: 'Password',
  props: ['value', 'placeholder'],
  data() {
    return {
      type: 'password',
      privateValue: '',
    };
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  created() {
    this.privateValue = this.value;
  },
  methods: {
    onInputFocus($event) {
      let target = $event.target;
      target.parentElement.classList.add('focus');
    },
    onInputBlur($event) {
      let target = $event.target;
      target.parentElement.classList.remove('focus');
    },
    onEnter() {
      this.$emit('enter');
    },
  },
  watch: {
    value() {
      this.privateValue = this.value;
    },
    privateValue() {
      this.$emit('change', this.privateValue);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-input__inner {
    border-right: 0 !important;
  }
  .el-input-group__append {
    padding: 0;
    background-color: transparent;
    padding-right: 21px;
    .view {
      cursor: pointer;
      background-size: 100% 100%;

      &.password {
        width: 20px;
        height: 9px;
        background-image: url('~@/assets/images/login/brow@2x.png');
      }

      &.text {
        width: 24px;
        height: 18px;
        background-image: url('~@/assets/images/login/eye@2x.png');
      }
    }
  }
}
</style>
